import { Fee } from "app/shared/model";

export function toFeeCode(fee: Fee): string {
    return `F${fee.id}`;
}

export function normalizeFeeCode(raw?: string | null): string | undefined {
    if (raw == null) return undefined;

    const s = String(raw).trim();
    if (!s) return undefined;

    if (/^F\d+$/.test(s)) return s;
    if (/^\d+$/.test(s)) return `F${s}`;

    return undefined;
}